import { ADD_STITCH_REQUEST, ADD_STITCH_SUCCESS, ADD_STITCH_ERROR, RESET_ADD_STITCH } from "../actions/addStitch"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const addStitch = (state = initialState, action) => {
    switch (action.type) {
        case ADD_STITCH_REQUEST:
            return {
                ...state,
                loading: true
            }

        case ADD_STITCH_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case ADD_STITCH_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case RESET_ADD_STITCH:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        default:
            return state;
    }
}

export default addStitch